import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoggingService } from '../utilities/services/logging.service';
import { HttpService } from '../utilities/services/http.service';
import { LogCreateDTO } from '../utilities/dtos/log.dto';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
})
export class ContactInfoComponent implements OnInit, AfterViewInit {

  constructor(private loggingService: LoggingService, private translate: TranslateService,
    private _snackBar: MatSnackBar, private httpService: HttpService) { }

  @Output() startChat = new EventEmitter();
  @Output() openAddresBook = new EventEmitter();
  @Output() openNewMessage = new EventEmitter();
  @Output() gotoConversations = new EventEmitter();
  @Output() closeUser = new EventEmitter();

  @Input() user: any;
  public isMobile = false;
  public isViewPage = false;
  callNote;
  addTag;
  tagList;
  editTags = false;
  isCaregiver = false;

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 810;
    window.onresize = () => this.isMobile = window.innerWidth <= 810;
    let userTags = this.user.user.tags ? this.user.user.tags : null;
    if (!userTags)
      this.tagList = [];
    else
      this.tagList = userTags.split(';');

    let userRole = localStorage.getItem('Role');
    if (userRole === "CAREGIVER")
      this.isCaregiver = true;
  }
  ngAfterViewInit(): void { }

  gotoAddressbook() {
    this.openAddresBook.emit(true);
  }

  gotoNewMessage() {
    this.openNewMessage.emit(true);
  }

  close() {
    this.closeUser.emit(true);
  }

  gotoChat() {
    const dataUser = {
      email: this.user.user.email,
      name: this.user.user.name
    }
    this.startChat.emit(dataUser);
  }

  gotoConversation() {
    this.gotoConversations.emit(true);
  }

  getEmail(user: any) {
    return 'mailto:' + user.email;
  }

  getPhone(user: any) {
    return 'tel:' + user.PhoneNumber;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  removeTag(tag: any): void {
    const index = this.tagList.indexOf(tag);
    if (index >= 0) {
      this.tagList.splice(index, 1);
      this.updateAllTags();
    }
  }

  clearCallNote() {
    this.callNote = "";
  }

  tagEdit() {
    this.editTags = !this.editTags;
  }

  async logCallNote() {
    let userId: any = localStorage.getItem('userId');
    let userName: any = localStorage.getItem('userName');
    let logObject: LogCreateDTO = {
      userId: userId,
      userName: userName,
      logType: "callLog",
      logTypeId: this.user.user._id,
      logDescription: userName + " Attempted To Call " + this.user.user.name,
      logDetail: userId + " clicked to dial " + this.user.user.email + " (" + this.user.user.PhoneNumber + ")"
    }
    this.loggingService.createCallLog(logObject).subscribe(res => {
      this.translate.get('CONTACTINFO.CREATE_CALL_NOTE').subscribe((res: string) => {
        this.openSnackBar(res, '');
      });
    })
  }

  clearTag() {
    this.addTag = "";
  }

  async addNewTag() {
    this.tagList.push(this.addTag);
    this.updateAllTags();
  }

  updateAllTags() {
    let userId: any = localStorage.getItem('userId');
    let userName: any = localStorage.getItem('userName');
    let tagListText = this.tagList.join(";")
    let logObject: LogCreateDTO = {
      userId: userId,
      userName: userName,
      logType: "addTag",
      logTypeId: this.user.user._id,
      logDescription: userName + " Changed User " + this.user.user.email + " Tags to " + tagListText,
      logDetail: this.user.user.tags + " to " + tagListText
    }
    this.loggingService.createCallLog(logObject).subscribe(res => {
      this.translate.get('CONTACTINFO.CHANGE_TAGS').subscribe((res: string) => {
        this.openSnackBar(res, '');
      });
    })

    this.httpService?.updateUserTags(tagListText, this.user.user.email).subscribe({
      complete: () => {
        console.log('done');
      },
      error: (error) => {
        console.log(error);

        const msg = error.error ? error.error.message : error.message;
        this.openSnackBar(msg, '');
      },
      next: (res) => {
        // console.log(res);
        this.clearTag();
        this.user.user.tags = tagListText;
      },
    });
  }

  getRoleName(role) {
    if (role.toLowerCase() === "support")
      return "SembraCare Success"
    else if (role.toLowerCase() === "specialtysupport")
      return "SembraCare Specialty Support"
    else if (role.toLowerCase() === "sembranetadmin")
      return "SembraNet Management"
    else if (role.toLowerCase() === "sembranetnurse")
      return "SembraNet Nurse"
    else if (role.toLowerCase() === "sembranetoffice")
      return "SembraNet Office"
    else if (role.toLowerCase() === "agencyadmin")
      return "Agency Admin"
    else if (role.toLowerCase() === "agencynurse")
      return "Agency Nurse"
    else
      return role.substring(0, 1) + role.substring(1, role.Length).toLowerCase()
  }
}
